// Date and time formatter utilities

// Format date to readable format (e.g., Mon, Mar 15, 2025)
//export function formatDate(dateString) {
//  const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
//  return new Date(dateString).toLocaleDateString(undefined, options);
//}

export function formatDate(dateString) {
  const [year, month, day] = dateString.split('-');
  const date = new Date(year, month - 1, day); // month is 0-indexed
  const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
  return date.toLocaleDateString(undefined, options);
}

export function formatDateToISO(dateString) {
  if (!dateString) return null;
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Format time from 24h to 12h format (e.g., 18:00:00 => 6:00 PM)
export function format12HourTime(timeString) {
  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours, 10);
  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${period}`;
}

// Group matches by date
export function groupMatchesByDate(matches) {
  const groupedMatches = {};

  matches.forEach(match => {
    if (!groupedMatches[match.date]) {
      groupedMatches[match.date] = [];
    }
    groupedMatches[match.date].push(match);
  });

  // Sort each group by time
  Object.keys(groupedMatches).forEach(date => {
    groupedMatches[date].sort((a, b) => {
      return new Date(`${a.date}T${a.time}`) - new Date(`${b.date}T${b.time}`);
    });
  });

  return groupedMatches;
}
